module.exports = __webpack_public_path__ + "static/media/logo.e65433e1.png";